export default (name, value) => {
  if (global.document && value) {
    const date = new Date()
    date.setDate(date.getDate() + 14)
    document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`
  }
}
